/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import * as RadixUiReactToggleGroup from "@radix-ui/react-toggle-group";
import type { ComponentProps } from "react";

import type { ThemeType } from "../../../../../global/emotion";
import { spacing } from "../../../../../global/emotion";

const radixUiReactToggleGroupRootStyle: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  borderBottomColor: theme.semanticColors.neutralsLowest,
  borderBottomStyle: "solid",
  borderBottomWidth: 2,
  display: "flex",
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
  width: "100%",
});
export const Tabs = ({
  children,
  ...props
}: ComponentProps<typeof RadixUiReactToggleGroup.Root>) => (
  <RadixUiReactToggleGroup.Root
    css={radixUiReactToggleGroupRootStyle}
    {...props}
  >
    {children}
  </RadixUiReactToggleGroup.Root>
);
